import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/pages/HomeView.vue'),
    },

    {
      path: '/add-payment-method',
      name: 'add-payment-method',
      component: () => import('@/pages/AddPaymentMethod.vue'),
    },

    {
      path: '/payment-success',
      name: 'payment-success',
      component: () => import('@/pages/PaymentSuccess.vue'),
    },
  ],
});

export default router;
